import Parser from "html-react-parser";
import React, { Component } from "react";
import { Info } from "../normalizer";

class CartWarning extends Component {
  render() {
    return (
      <div className="cart-warning">
        <Info className="cart-warning-icon" />
        <div className="cart-warning-content">
          <div className="cart-warning-header">
            <p>Informações importantes</p>
          </div>
          <div className="cart-warning-text">
            {Parser(this.props.text)}
          </div>
        </div>
      </div>
    );
  }
}

export default CartWarning;
